import { CardContent } from "@material-ui/core"
import { Alert, Card } from "@mui/material"

export default function PennantOverview() {
    return (
        <div className="light-text margin padding flex-column">
            <h2 className="pennant-option-title">ANU Pennant Overview</h2>
            <Card>
                <CardContent>
                    <p>ANUTC Pennant is for a better tennis environment and growing our community. It is only available for ANU Tennis Club members.</p>
                </CardContent>
            </Card>
            <h2 className="pennant-option-title">Match format</h2>
            <Card>
                <CardContent>
                    <p>
                        Each player is assigned a team and position (t1p1 - Team 1, Position 1), where two teams will face off in a series of singles and doubles rubbers.
                    </p>
                    <p>
                        For 3v3 matches, each player will verse the same position on the opposing team in singles and the remaining four players will play doubles. An example of a 3v3 match will proceed as follows:
                    </p>
                    <p>
                        t1p1 v t2p1,  t1p2&t1p3 v t2p2&t2p3
                    </p>
                    <p>
                        t1p2 v t2p2,  t1p1&t1p3 v t2p1&t2p3
                    </p>
                    <p>
                        t1p3 v t2p3,  t1p1&t1p2 v t2p1&t2p2
                    </p>
                    <p>
                        For 2v2 matches, each team will first play doubles, then each player will play singles against both opposing players. An example of a 2v2 match will proceed as follows:
                    </p>
                    <p>
                        t1p1&t1p2 v t2p1&t2p2
                    </p>
                    <p>
                        t1p1 v t2p1,  t1p2 v t2p2
                    </p>
                    <p>
                        t1p1 v t2p2,  t1p2 v t2p1
                    </p>
                    <p>
                        Each rubber will be played as one full set (First to 6 games, lead by 2, standard tiebreaker at 6-6), but with a short deuce (At 40-40, next point wins the game and receiver chooses which side).
                    </p>
                </CardContent>
            </Card>

            <Alert severity="warning">
                <p>
                    The current season's final match is on the 6th August. Afterwards, members will receive an email for the total amount owed for the season. Cost per match per person is $8 - if you find any issues with your payment at the end of the season, please reply to our email.
                </p>
                <p>
                    Please keep in mind that you may not be able to participate in further seasons if you do not pay any outstanding amounts.
                </p>
            </Alert>
        </div>

    )
}
